/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetAvailableClassesRequest
 */
export interface GetAvailableClassesRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetAvailableClassesRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAvailableClassesRequest
     */
    seasonId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetAvailableClassesRequest
     */
    locationId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetAvailableClassesRequest
     */
    onlyAvailableOnline?: boolean | null;
}

/**
 * Check if a given object implements the GetAvailableClassesRequest interface.
 */
export function instanceOfGetAvailableClassesRequest(value: object): value is GetAvailableClassesRequest {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    return true;
}

export function GetAvailableClassesRequestFromJSON(json: any): GetAvailableClassesRequest {
    return GetAvailableClassesRequestFromJSONTyped(json, false);
}

export function GetAvailableClassesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAvailableClassesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'seasonId': json['seasonId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['seasonId']),
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'onlyAvailableOnline': json['onlyAvailableOnline'] == null ? undefined : json['onlyAvailableOnline'],
    };
}

export function GetAvailableClassesRequestToJSON(json: any): GetAvailableClassesRequest {
    return GetAvailableClassesRequestToJSONTyped(json, false);
}

export function GetAvailableClassesRequestToJSONTyped(value?: GetAvailableClassesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'seasonId': ActorActivityRecordActorUserIdToJSON(value['seasonId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'onlyAvailableOnline': value['onlyAvailableOnline'],
    };
}

